import React from 'react';
import { FormikProvider, useFormik, Form } from 'formik';
import {
  Layout, Spin,
} from 'antd';
import { Link } from 'react-router-dom';
import { useActions } from '../../providers/actions-provider/actions.context';
import FormControl from '../../lib/form-control';
import { SIGN_IN_PATH } from '../../routing/paths.constants';
import LogoButton from '../../lib/logo-button';
import { ReactComponent as Check } from '../../../assets/icons/check.svg';
import { resetPasswordValidation, errorMessages } from './reset-password.validation';
import { useStore } from '../../../store';

type IErrorKeys = 'characters' | 'capital' | 'lowercase' | 'number' | 'specialCharacter';

const validationCards = Object.entries(errorMessages);

const ResetPassword = (): JSX.Element => {
  const { userActions } = useActions();
  const { auth: { loading } } = useStore();
  const formik = useFormik({
    initialValues: {
      code: '',
      password: '',
      repeatPassword: '',
      resetCode: '',
      ...errorMessages,
    },
    initialErrors: errorMessages,
    onSubmit: ({ code, password }) => {
      userActions.resetPassword({ password, token: code });
    },
    enableReinitialize: true,
    validate: resetPasswordValidation,
  });

  const { errors } = formik;

  return (
    <Layout className="auth-layout auth-layout__reset-pass">
      <div className="form">
        <LogoButton />
        <FormikProvider value={formik}>
          {loading ? (
            <Spin size="large" style={{ margin: 'auto' }} />
          ) : (
            <Form className="auth-layout__form">
              <h2 className="auth-layout__form-title">Create new password</h2>
              <p className="form__text">Please create a secure password including the following criteria below.</p>
              <div>
                <FormControl name="password" label="Password" type="password" inputClassName="form__input" wrapperClassName="form__label" />
                <div className="validation">
                  {validationCards.map(((card) => {
                    const key = card[0] as IErrorKeys;
                    const isDone = !errors[key];
                    const cardStyles = isDone ? 'validation__option validation__option-done' : 'validation__option';
                    return (
                      <div className={cardStyles} key={card[1]}>
                        {isDone && <Check />}
                        <span>
                          {card[1]}
                        </span>

                      </div>
                    );
                  }))}
                </div>
              </div>
              <FormControl name="repeatPassword" label="Repeat password" type="password" inputClassName="form__input" wrapperClassName="form__label" />
              <FormControl name="code" label="Reset Code" type="text" inputClassName="form__input auth" wrapperClassName="form__label" />
              <button type="submit" className="auth-layout__form-submit">
                Reset Password
              </button>
              <div className="auth-layout__forgot-password reset-password__back">
                <Link to={SIGN_IN_PATH}>Back to Login In</Link>
              </div>
            </Form>
          )}
        </FormikProvider>
      </div>
    </Layout>
  );
};

ResetPassword.displayName = 'ResetPassword';

export default ResetPassword;
